import React from "react";

import GridBarFiltersAtomCheckbox from "@/components/Grid/Bar/Filters/Atom/Checkbox";
import LayoutSidebarFiltersAtomHeader from "@/components/Grid/Bar/Filters/Atom/Header";

export default function LayoutSidebarFiltersSuperPools() {
  return (
    <LayoutSidebarFiltersAtomHeader name="superpools" hideCount>
      <GridBarFiltersAtomCheckbox filter="superpools" label="Only show superpools" defaultIsChecked={false} />
    </LayoutSidebarFiltersAtomHeader>
  );
}
